import { APICore } from './apiCore';

const api = new APICore();

function login(params: { username: string; password: string }) {
    const baseUrl = '/auth/login';
    const urlParams = new URLSearchParams();
    urlParams.append('username', params.username);
    urlParams.append('password', params.password);

    return api.create(`${baseUrl}`, urlParams);
}

function logout() {
    const baseUrl = '/auth/logout';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string; password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { username: string }) {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

function forgotPasswordConfirm(params: { email: string }) {
    const baseUrl = '/password/reset/confirm/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword, forgotPasswordConfirm };
